export const LinkedinErrorConnector = () => {
  return <div>Error</div>;
};
